import { z } from "zod";
import { DbCreateInputOmit, DbUpdate } from "../helpers";
import { OmitStrict } from "../utils";
import { ColorTokenInlineData } from "./properties";

export const CollectionOrigin = z.object({
  id: z.string(),
  sourceId: z.string(),
});

export const Collection = z.object({
  id: z.string(),
  persistentId: z.string(),

  designSystemVersionId: z.string(),

  name: z.string(),
  description: z.string(),
  backgroundColor: ColorTokenInlineData.optional(),

  /**
   * ID of Select element property definition's option that corresponds to this collection.
   *
   * Each collection is represented by an option in a special kind of element property that
   * is present in each design system where a collections are present. The property is maintained
   * automatically and is not available to the user (see immutable element properties).
   *
   * Collections have an immutable element property that allows bridging places where element properites
   * can be selected (e.g. documentation blocks) with the concept of collection without having to add
   * specific logic for collection selection.
   */
  elementPropertyOptionId: z.string(),

  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),

  sortOrder: z.string(),

  origin: CollectionOrigin.optional(),
});

export type CollectionOrigin = z.infer<typeof CollectionOrigin>;
export type Collection = z.infer<typeof Collection>;

export type CreateCollection = OmitStrict<DbCreateInputOmit<Collection>, "elementPropertyOptionId">;
export type UpdateCollection = OmitStrict<
  DbUpdate<Collection>,
  "designSystemVersionId" | "origin" | "elementPropertyOptionId"
> & {
  origin?: Partial<CollectionOrigin>;
};
